// extracted by mini-css-extract-plugin
export var readonly = "_dj-1";
export var star = "_dj-0";